import React, { FunctionComponent } from 'react';
import styled, { keyframes } from 'styled-components';
import { BrainLeftIcon, BrainRightIcon } from '../assets/icons';

export const LoadingSpinner: FunctionComponent = () => (
  <Loader>
    <Container>
      <AnimationContainer animation="up">
        <Brain>
          <BrainLeftIcon alt="Mindset Health Logo" />
        </Brain>
      </AnimationContainer>
      <AnimationContainer animation="down">
        <Brain>
          <BrainRightIcon alt="Mindset Health Logo" />
        </Brain>
      </AnimationContainer>
    </Container>
  </Loader>
);

const Loader = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  bottom: 50%;
  text-align: center;
`;

const Float = (animation: 'up' | 'down') => keyframes`
	0% { transform: translatey(${animation === 'up' ? '6px' : '-7px'}); }
	50% { transform: translatey(0px);}
	100% { transform: translatey(${animation === 'up' ? '6px' : '-7px'}); }
`;

const AnimationContainer = styled.div<{ animation: 'up' | 'down' }>`
  animation-name: ${({ animation }) => (animation === 'up' ? Float('up') : Float('down'))};
  animation-duration: 3s;
  animation-iteration-count: infinite;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  > div:first-child {
    transform: translatey(6px);
    padding-right: 1px;
  }
  > div:last-child {
    transform: translatey(-7px);
    padding-left: 1px;
  }
`;

const Brain = styled.div`
  width: 25px;
  height: 50px;
  margin-left: 2px;
  margin-top: -15px;
  transform: translatey(0px);
  animation: float 6s ease-in-out infinite;
  img {
    width: 100%;
    height: auto;
  }
`;
